import { forwardRef, type ComponentProps } from 'react';
import { Link, useLocation } from 'react-router-dom';

type LinkWithModalSupportProps = ComponentProps<typeof Link>;

export const LinkWithModalSupport = forwardRef<HTMLAnchorElement, LinkWithModalSupportProps>(
  (props, ref) => {
    const location = useLocation();
    return <Link {...props} ref={ref} state={{ ...props.state, backgroundLocation: location }} />;
  }
);

LinkWithModalSupport.displayName = 'LinkWithModalSupport';
